module.exports = __webpack_public_path__ + "939128f36c5bab84344fb9767b48afce.pdf";